<img [src]="profilePic" [class]="class" alt="" (error)="changeSrcToDefault($event)" class="profile-pic">
